import React from 'react'
import Markdown from 'markdown-to-jsx'
import ppEnMd from './pp-en.md'

const PrivacyPolicyEN = () => {
  return <Markdown>{ppEnMd}</Markdown>
}

export default PrivacyPolicyEN
